import type { FunctionComponent } from 'react';
import React from 'react';
import { useTheme } from '@material-ui/core/styles';

/**
 * Name step icon.
 */
export const NameIcon: FunctionComponent<{ size?: number }> = ({ size = 62 }) => {
  const theme = useTheme();

  return (
    <svg width={size} height={size} viewBox="0 0 62 62">
      <path
        d="M31 59.417c15.694 0 28.417-3.47 28.417-7.75 0-4.28-12.723-7.75-28.417-7.75s-28.417 3.47-28.417 7.75c0 4.28 12.723 7.75 28.417 7.75z"
        fill="#CAD0D4"
      />
      <path d="M31 15.5a6.458 6.458 0 100-12.916A6.458 6.458 0 0031 15.5z" fill={theme.palette.primary.main} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M27.12 18.084c-3.564 0-6.453 2.903-6.453 6.46v10.083c0 .708.539 1.497 1.205 1.763l2.67 1.069 1.174 12.922c.065.71.703 1.286 1.405 1.286h7.758c.711 0 1.34-.575 1.405-1.286l1.174-12.922 2.65-.884c.677-.225 1.225-.99 1.225-1.709v-10.33a6.457 6.457 0 00-6.454-6.453h-7.758z"
        fill={theme.palette.primary.main}
      />
    </svg>
  );
};
